<template>
  <div class="card">
    <v-form>
      <div class="Login-title mb-1">
        <v-icon v-if="isForgotPassword" class="mr-1" @click="$router.push('/forgetpassword')"
          >mdi mdi-chevron-left</v-icon
        >
        {{isForgotPassword? "Forgot your password?": "Verify OTP"}}
      </div>
      <div class="img-wrapper">
        <img
          :src="require('../assets/otp_recolored.svg')"
          alt="Forgot Password"
          style="height: 125px; width: 140px"
        />
      </div>

      <div class="text-wrapper pl-1">
        <p class="instructions">Please enter the Verification Code.</p>
        <p class="instructions-text">
          Enter the 6-digit verification code sent to your Email ID
          <!-- sr*****27@gmail.com -->
        </p>
      </div>
      <span v-if="error" class="text-error d-block text-center">{{ errorMessage }}</span>

      <div class="otp-container mb-2">
        <v-text-field
          v-for="n in 6"
          :key="n"
          :ref="'otp' + n"
          class="otp-box custom-text-field"
          v-model="otp[n - 1]"
          maxlength="1"
          variant="outlined"
          density="compact"
          hide-details
          @input="onInput(n)"
          @keydown="onKeydown($event, n)"
        ></v-text-field>
      </div>
      <div class="pl-1 receive">
        Didn’t receive the email?
        <span v-if="timer > 0" class="timer-text">Resend available in {{ formattedTime }}</span>
        <template v-else>
          <a @click="sendOtp($route.query.mail)" class="resend">Click here </a> to resend.
        </template>
      </div>
      <div class="pl-1">
        <v-btn
          color="#1b1a47"
          block
          size="large"
          :loading="loading"
          class="log-btn text-white mt-3"
          @click="verify"
        >
          Verify
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import ResetPasswordService from '@/api/service/ResetPasswordService';
export default {
  data() {
    return {
      otp: Array(6).fill(""),
      loading: false,
      error: false,
      errorMessage: '',
      isForgotPassword: true,
      timer: 300,
      timerInterval: null
    };
  },
  computed: {
    formattedTime() {
      const hours = Math.floor(this.timer / 3600);
      const minutes = Math.floor((this.timer % 3600) / 60);
      const seconds = this.timer % 60;
      if (hours > 0) {
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      }
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }
  },
  methods: {
    async resend() {},
    startTimer(seconds = 300) {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }
      this.timer = seconds;
      this.timerInterval = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          clearInterval(this.timerInterval);
          this.timerInterval = null;
        }
      }, 1000);
    },
    onInput(n) {
      if (this.otp[n - 1] && n < 6) {
        const next = this.$refs['otp' + (n + 1)];
        const el = Array.isArray(next) ? next[0] : next;
        el?.$el?.querySelector('input')?.focus();
      }
    },
    onKeydown(event, n) {
      if (event.key === 'Backspace' && !this.otp[n - 1] && n > 1) {
        const prev = this.$refs['otp' + (n - 1)];
        const el = Array.isArray(prev) ? prev[0] : prev;
        el?.$el?.querySelector('input')?.focus();
      }
    },
    async verify() {
      let verify = await ResetPasswordService.verifyOtp({email:this.$route.query.mail, otp:this.otp.join('')})
      const redirectUrl = localStorage.getItem("REDIRECT_URL")
      if(verify.data.message == 'OTP verified successfully'){
        window.location = redirectUrl + "?token=" + this.$route.query.token;
      }
      if(verify.data.message == 'OTP not found' || verify.data.message == 'Invalid OTP'){
        this.errorMessage = 'Invalid OTP'
        this.error = true
      }
      if(verify.data.message == 'OTP expired'){
        this.errorMessage = verify.data.message
        this.error = true
      }
    },
    async sendOtp($mail) {
      try {
        let response = await ResetPasswordService.sendOtp({ email: $mail });
        console.log(response);
        const resData = response?.data?.data || response?.data || response;
        this.handleOtpResponse(resData);
      } catch (err) {
        console.error(err);
        const resData = err?.response?.data?.data || err?.response?.data || err;
        this.handleOtpResponse(resData);
      }
    },
    handleOtpResponse(resData) {
      const isMaxResendReached =
        resData?.resendCount >= 3 ||
        resData?.resendsRemaining === 0 ||
        (resData?.resendCount && resData?.maxResends && resData?.resendCount >= resData?.maxResends) ||
        (resData?.remainingMinutes && resData?.remainingMinutes > 5);

      if (isMaxResendReached) {
        this.error = true;
        this.errorMessage = resData?.message || 'You have reached the maximum resend limit (3 times). Please try again after 2 hours.';
        let remainingSec = 300;
        if (resData?.remainingMs) {
          remainingSec = Math.ceil(resData.remainingMs / 1000);
        } else if (resData?.remainingMinutes) {
          remainingSec = resData.remainingMinutes * 60;
        }
        this.startTimer(remainingSec);
      } else {
        this.error = false;
        this.errorMessage = '';
        this.startTimer(300);
      }
    }
  },
  async created(){
    if(this.$route?.query && this.$route?.query?.mail && this.$route?.query?.token){
      this.isForgotPassword = false
    }
    await this.sendOtp(this.$route.query.mail)
  },
  beforeUnmount() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }
};
</script>
<style scoped>
.Login-title {
  font-size: 16px;
  font-weight: 500;
}

.img-wrapper {
  display: flex;
  justify-content: center;
}

.img-wrapper img {
  width: 100%;
  height: 150px;
  max-width: 200px;
}

.text-wrapper {
  margin-bottom: 16px;
}

.instructions {
  font-size: 13px;
  color: #565656;
  margin: 0;
}

.instructions-text {
  font-size: 11px;
  color: #686868;
  /* margin: 4px 0 0 0; */
}

.log-btn {
  font-weight: 600;
  border-radius: 4px;
  /* margin-top: 16px; */
}

.custom-text-field {
  margin-top: 12px;
}

>>> .v-field--error:not(.v-field--disabled) .v-field__prepend-inner > .v-icon,
.v-field--error:not(.v-field--disabled) .v-field__append-inner > .v-icon,
.v-field--error:not(.v-field--disabled) .v-field__clearable > .v-icon {
  color: #5e5f60 !important;
}

.otp-container {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.otp-box {
  width: 45px;
  text-align: center;
}

.receive {
  font-size: 12px;
  color: #565656;
}

.resend {
  color: #1b1a47;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
}

.timer-text {
  font-weight: 600;
  color: #1b1a47;
}
</style>
